export enum Link {
  Contact = 'https://cawood.co.uk/hub-enquiries/',
  Legal = 'https://cawood.co.uk/about-cawood/legal-information/',
  Terms = 'https://cawood.co.uk/website-terms/',
  Privacy = 'https://cawood.co.uk/privacy-policy',
  Cookies = 'https://cawood.co.uk/cookies-policy/',
  Supplies = 'https://cawood.co.uk/order-supplies/',
  Courier = 'https://cawood.co.uk/services/book-sample-collection',
}
